import { render, staticRenderFns } from "./FacilityImages.vue?vue&type=template&id=219affe2&scoped=true"
import script from "./FacilityImages.vue?vue&type=script&lang=js"
export * from "./FacilityImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219affe2",
  null
  
)

export default component.exports